import React, { useEffect, useState } from "react";
import {
  Button,
  SelectChangeEvent,
  Stack,
  Tab,
  TablePagination,
  Tabs,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterIcon from "src/assets/svg-icons/aggregators/filter.svg";
import SalesInvoicesTable from "./table";
import FilterDrawer from "./filters";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { oneBranchHasPermission } from "src/utils";
import { SalesPermissions } from "src/constants/permissions";
import { useGetSalesInvoices } from "src/api/sales/invoices";
import { getTabA11yProps } from "src/shared/components/tabs/tab-props";

const SalesInvoices = () => {
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [branches, setBranches] = useState<number[]>([]);
  const [refNum, setRefNum] = useState("");
  const [type, setType] = useState("all");
  const [invoiceType, setInvoiceType] = useState("invoice");
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const { t: salesT } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");
  const [dateRange, setDateRange] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: "",
    endDate: "",
  });

  const { data, isFetching, refetch } = useGetSalesInvoices({
    page: pageNumber + 1,
    type: invoiceType as "invoice" | "credit_note",
    // start_date: dateRange.startDate || undefined,
    // end_date: dateRange.endDate || undefined,
    // ...(!!refNum && { reference_number: refNum }),
    // ...(branches.length > 0 && { branches: branches }),
  });

  // permissions
  const addPermission = oneBranchHasPermission(SalesPermissions.addSaleInvoice);

  const labels = [salesT("salesInvoices"), salesT("creditNote")];

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChangeType = (event: SelectChangeEvent) => {
    setInvoiceType(event.target.value);
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setInvoiceType(newValue === 0 ? "invoice" : "credit_note");
  };

  useEffect(() => {
    if (!open) {
      setPageNumber(0);
      refetch();
    }
  }, [open]);

  useEffect(() => {
    if (
      !!dateRange.endDate ||
      (dateRange.endDate === undefined && dateRange.startDate === undefined)
    ) {
      refetch();
    }
  }, [dateRange.endDate, dateRange.startDate]);

  useEffect(() => {
    if (data) {
      setTotal(data.meta.total);
    }
  }, [data]);

  return (
    <Stack spacing={1.5}>
      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        {/* <Typography fontWeight={600} lineHeight={"19.2px"} color={"#475467"}>
          {salesT("salesInvoices")}
        </Typography> */}
        <Tabs value={value} onChange={handleChangeTab}>
          {labels.map((label, index) => {
            return (
              <Tab
                disableRipple
                key={`${index}_${label}`}
                label={label}
                {...getTabA11yProps(index)}
              />
            );
          })}
        </Tabs>

        <Stack direction={"row"} gap={2}>
          {/* <Box sx={{ minWidth: 207 }}>
            <DateRangeInput
              startDate={
                dateRange.startDate ? moment(dateRange.startDate) : null
              } // moment.Moment | null
              startDateId={`your_unique_start_date_id`}
              endDate={dateRange.endDate ? moment(dateRange.endDate) : null} // moment.Moment | null
              endDateId={`your_unique_end_date_id`}
              onDatesChange={(arg: {
                startDate: moment.Moment | null;
                endDate: moment.Moment | null;
              }) => {
                setDateRange({
                  startDate: arg.startDate?.format("yyyy-MM-DD") as string,
                  endDate: arg.endDate?.format("yyyy-MM-DD") as string,
                });
                setPageNumber(0);
              }}
              showClearDates
            />
          </Box> */}
          {/* <Button
            color="tertiary"
            variant="outlined"
            size="small"
            endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
            sx={{ height: "40px" }}
            onClick={handleOpen}
          >
            {generalT("filter")}
          </Button> */}
          {addPermission && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/sales/invoices/add-invoice")}
            >
              {salesT("addInvoice")}
            </Button>
          )}
        </Stack>
      </Stack>
      <SalesInvoicesTable
        rows={data?.data}
        isLoading={isFetching}
        refetch={refetch}
      />
      <TablePagination
        sx={{ mt: 1 }}
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
      {/* Filter Drawer */}
      <FilterDrawer
        open={open}
        setBranches={setBranches}
        branches={branches}
        refNum={refNum}
        setRefNum={setRefNum}
        handleClose={handleClose}
        type={type}
        setType={setType}
      />
    </Stack>
  );
};

export default SalesInvoices;
